export const BOARD_SECTIONS = {
  generated: 'generated',
  in_work: 'in_work',
  done: 'done',
  completed: 'completed',
};

export const Statuses = ['generated', 'in_work', 'done', 'completed'];